export enum FeatureAccessResult {
  ALLOW = 'allow',
  DENY = 'deny',
  HIDDEN = 'hidden',
}

/**
 * Combines platform feature availability with user authorization.
 * Feature flags and permissions remain independent inputs.
 */
export function evaluateFeatureAccess(
  featureEnabled: boolean,
  hasPermission: boolean,
): FeatureAccessResult {
  if (!featureEnabled) {
    return FeatureAccessResult.HIDDEN;
  }

  if (!hasPermission) {
    return FeatureAccessResult.DENY;
  }

  return FeatureAccessResult.ALLOW;
}

export function isFeatureAccessAllowed(
  featureEnabled: boolean,
  hasPermission: boolean,
): boolean {
  return evaluateFeatureAccess(featureEnabled, hasPermission) === FeatureAccessResult.ALLOW;
}

export function shouldHideFeature(featureEnabled: boolean): boolean {
  return !featureEnabled;
}

export function isPermissionDenied(
  featureEnabled: boolean,
  hasPermission: boolean,
): boolean {
  return (
    featureEnabled &&
    evaluateFeatureAccess(featureEnabled, hasPermission) === FeatureAccessResult.DENY
  );
}
